var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "award"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.195 8.265V11.9925C3.195 13.3575 3.195 13.3575 4.485 14.2275L8.0325 16.275C8.565 16.5825 9.435 16.5825 9.9675 16.275L13.515 14.2275C14.805 13.3575 14.805 13.3575 14.805 11.9925V8.265C14.805 6.9 14.805 6.9 13.515 6.03L9.9675 3.9825C9.435 3.675 8.565 3.675 8.0325 3.9825L4.485 6.03C3.195 6.9 3.195 6.9 3.195 8.265Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.125 5.7225V3.75C13.125 2.25 12.375 1.5 10.875 1.5H7.125C5.625 1.5 4.875 2.25 4.875 3.75V5.67",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.4725 8.2425L9.9 8.91C9.9675 9.015 10.1175 9.12 10.23 9.15L10.995 9.345C11.4675 9.465 11.595 9.87 11.2875 10.245L10.785 10.8525C10.71 10.95 10.65 11.1225 10.6575 11.2425L10.7025 12.03C10.7325 12.5175 10.3875 12.765 9.9375 12.585L9.2025 12.2925C9.09 12.2475 8.9025 12.2475 8.79 12.2925L8.055 12.585C7.605 12.765 7.26 12.51 7.29 12.03L7.335 11.2425C7.3425 11.1225 7.2825 10.9425 7.2075 10.8525L6.705 10.245C6.3975 9.87 6.525 9.465 6.9975 9.345L7.7625 9.15C7.8825 9.12 8.0325 9.0075 8.0925 8.91L8.52 8.2425C8.79 7.8375 9.21 7.8375 9.4725 8.2425Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.031abcd3b3953a8c18e328885da6f827.svg";
export { ForwardRef as ReactComponent };